// extracted by mini-css-extract-plugin
export default {"container":"xq-z","brandName":"yq-z","productName":"zq-z","productNamePdpEnhancements":"Aq-z","breakLongProductName":"Bq-z"};